import { render, staticRenderFns } from "./woocommerce.vue?vue&type=template&id=0d8102a0&scoped=true"
import script from "./woocommerce.vue?vue&type=script&lang=js"
export * from "./woocommerce.vue?vue&type=script&lang=js"
import style0 from "./woocommerce.vue?vue&type=style&index=0&id=0d8102a0&prod&scoped=true&lang=css"
import style1 from "./woocommerce.vue?vue&type=style&index=1&id=0d8102a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8102a0",
  null
  
)

export default component.exports